export const ConsumptionTypes = {
  CONSUMPTION: "Consumption",
  PRODUCTION: "Production"
}



// WEBPACK FOOTER //
// ./src/enums/ConsumptionTypes.js